import React from "react";
import { useTranslation } from "react-i18next";
import { FullRuleset } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteRulesetDialog}
 */
export type DeleteRulesetDialogProps = {
    /** The ruleset to delete */
    ruleset: FullRuleset | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback function when the Dialog is closed */
    onClose: () => void;
    /** Callback function when the ruleset is deleted */
    onDelete: () => void;
};

/**
 * A dialog for deleting a ruleset
 */
export default function DeleteRulesetDialog(props: DeleteRulesetDialogProps) {
    const [t] = useTranslation("dialog-delete-ruleset");

    if (!props.ruleset) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.ruleset) return;
                await ApiInternal.rulesets.delete(props.ruleset.uuid);
                notify.success(t("toast.delete-ruleset"));
                props.onDelete();
            }}
            title={t("heading.delete-ruleset", { ruleset: props.ruleset.name })}
            description={t("description.delete-ruleset")}
            confirmLabel={t("button.delete-ruleset")}
        />
    );
}
